import React, {useState, useEffect} from 'react'
import VerNiveles from './VerNiveles'
import SubirEditNiveles from './SubirEditNiveles'
import Eliminar  from '../componentes/Eliminar'
import Header from '../componentes/Header';
import useTraeDatos from '../hooks/useTraeDatos';
import {Titulos, peticionDelete} from '../hooks/Funciones'

const NivelesAdmin = ({baseUrl, titulo}) => {

	const [tituloPag, setTituloPag] = useState(titulo)
	const [registroSelect, setRegistroSelect] = useState({})
	const [funcion, setFuncion] = useState('ver')
	const [cargas, setCargas] = useTraeDatos(baseUrl)
	const [copiaCargas] = useTraeDatos(baseUrl)
	const [busqueda, setBusqueda] = useState('')
	const TitulosPagina = ['Ver Niveles', 'Crear Nivel', 'Editar Nivel', 'Eliminar Nivel', 'Niveles']

	const seleccionaRegistro = (dato, funcion) => e =>{
		setRegistroSelect({...dato, imagePrev: dato.imagen})
		setFuncion(funcion === 'eliminar' ? 'eliminar' : 'editar')
	}

	const RecibeBusqueda = e => {
		setBusqueda(e.target.value)
		filtrar(e.target.value)
	}

	const filtrar = (termino) => {
		let resultado = copiaCargas.filter((item) => {
			if(item.nombre.toLowerCase().includes(termino.toLowerCase())){
				return item
			} 
		})
		setCargas(resultado)
	}

	const peticionDeletee = () =>{peticionDelete(registroSelect, baseUrl, cargas, setCargas, setFuncion)}
	useEffect(() => {Titulos (funcion, setTituloPag, TitulosPagina)},[funcion])

	const ReiniciarPaginacion = () => {
		setCargas(copiaCargas)
		setBusqueda('')
	}

	return(
		<div>
			<Header 
				titulo={tituloPag} 
				funcion={funcion} 
				setFuncion={setFuncion} 
				Pagina={'Cursos'} 
				RecibeBusqueda={RecibeBusqueda} 
				busqueda={busqueda}
				resetBusq={ReiniciarPaginacion}
			/>
            {funcion === 'crear' ?
                <SubirEditNiveles
					baseUrl={baseUrl} 
					setFuncion={setFuncion}
					data={cargas} 
					setData={setCargas}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag} 
					funcion={funcion}/>

			:null}
			{funcion === 'editar' ?
				<SubirEditNiveles
					baseUrl={baseUrl} 
					setFuncion={setFuncion}
					data={cargas} 
					setData={setCargas}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag} 
					registroSelect={registroSelect}
					funcion={funcion}/>
			:null}
			{funcion === 'ver' ?
				<VerNiveles
					data={cargas} 
					seleccionaRegistro={seleccionaRegistro}
					baseUrl={baseUrl}
				/>
			:null}
			{funcion === 'eliminar' ?
				<Eliminar 
					nombre={'Operador'}
					select={registroSelect}
					setFuncion={setFuncion}
					peticionDelete={peticionDeletee}/>
				
			:null}
		</div>
	)
}

export default NivelesAdmin